module.exports = __webpack_public_path__ + "static/img/lucky_base.a2a10408.png";